// import { useState, useEffect } from "react";
// import { Card, Switch, Button, Avatar, Divider, Select, message, Spin } from "antd";
// import { UserOutlined, SaveOutlined, AppstoreOutlined } from "@ant-design/icons";
// import { getRequest, postRequest } from "../utils/APICall";

// const pageGroups = {
//   "Common Pages": ["Home"],
//   "HR / Admin Controls": [
//     "Add Leave",
//     "Department",
//     "Designation",
//     "Employees",
//     "Employee Report Emails",
//     "Financial Year Leaves",
//     "Holiday",
//     "Mark Attendance",
//     "Today Attendance",
//     "Tasks",
//     "Task Overview",
//     "Users",
//     "Users Control",
//     "Worksheet",
//   ],
//   "Employee Self Service": ["Leaves Summary", "PaySlip", "PaySlip Structure"],
//   "Report": ["Attendance Sheet", "Monthly Report", "Late Attendance Report" ,"Early Exit Report"],
// };

// const userRoles = [
//   { label: "Admin", value: 1 },
//   { label: "HR", value: 4 },
//   { label: "Accountant", value: 5 },
//   { label: "Employee", value: 2 },
//   { label: "Client", value: 3 },
// ];

// const UserAccessControl = () => {
//   const [roleId, setRoleId] = useState(null);
//   const [permissions, setPermissions] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [submitLoading, setSubmitLoading] = useState(false);

//   // 🔹 Load permissions when role changes
//   useEffect(() => {
//     if (!roleId) return;

//     const fetchPermissions = async () => {
//       setLoading(true);
//       try {
//         const res = await getRequest(`getUserControl?roleid=${roleId}`);
//         // console.log(res)
//         // Expected res: [{ pageName: "Home", canAccess: 1 }, ...]
//         console.log(res)
//         const permObj = {};
//         if(res.success){

//           res?.data?.forEach((item) => {
//             permObj[item.PAGE_NAME] = item.CAN_ACCESS === 1 ;
//           });
//           setPermissions(permObj);
//         }
//       } catch (err) {
//         console.error(err);
//         message.error("Failed to load permissions");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPermissions();
//   }, [roleId]);

//   // 🔹 Toggle single permission
//   const togglePermission = (page) => {
//     setPermissions((prev) => ({ ...prev, [page]: !prev[page] }));
//   };

//   // 🔹 Toggle group permissions
//   const toggleGroup = (pages, value) => {
//     const updated = {};
//     pages.forEach((p) => (updated[p] = value));
//     setPermissions((prev) => ({ ...prev, ...updated }));
//   };

//   // 🔹 Save permissions API
//   const handleSave = async () => {
//     setSubmitLoading(true)
//     const payload = { roleId, permissions };
//     console.log(payload)
//     try {
//       const res = await postRequest("usercontrol", payload);
//       if (res.success) {
//         message.success("Permissions saved successfully!");
//         setPermissions({})
//         setRoleId(null)
//       }
//     } catch (err) {
//       console.error(err);
//       message.error("Failed to save permissions");
//     } finally{
//       setSubmitLoading(false)
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-800">User Page Access Control</h1>
//             <p className="text-gray-500">Manage page permissions per role</p>
//           </div>

//           <Button
//             type="primary"
//             icon={<SaveOutlined />}
//             size="large"
//             className="rounded-xl"
//             disabled={!roleId}
//             onClick={handleSave}
//             loading={submitLoading}
//           >
//             Save Changes
//           </Button>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//           {/* Role Select */}
//           <Card className="rounded-2xl shadow-sm md:col-span-1">
//             <div className="flex items-center gap-4 mb-4">
//               <Avatar size={48} icon={<UserOutlined />} />
//               <div>
//                 <p className="font-semibold text-gray-800">Select Role</p>
//                 <p className="text-sm text-gray-500">Assign page access</p>
//               </div>
//             </div>

//             <Select
//               placeholder="Select Role"
//               value={roleId}
//               onChange={(value) => setRoleId(value)}
//               className="w-full"
//               options={userRoles}
//             />
//           </Card>

//           {/* Access Control */}
//           <Card
//             className="md:col-span-3 rounded-2xl shadow-sm"
//             title={
//               <div className="flex items-center gap-2">
//                 <AppstoreOutlined />
//                 Page Permissions
//               </div>
//             }
//           >
//             {loading ? (
//               <div className="flex justify-center py-10">
//                 <Spin size="large" />
//               </div>
//             ) : (
//               Object.entries(pageGroups).map(([group, pages]) => (
//                 <div key={group} className="mb-8">
//                   <Divider orientation="left">
//                     <div className="flex items-center gap-3">
//                       <span className="font-semibold text-gray-700">{group}</span>

//                       <Button size="small" onClick={() => toggleGroup(pages, true)}>
//                         Select All
//                       </Button>

//                       <Button size="small" onClick={() => toggleGroup(pages, false)}>
//                         Clear
//                       </Button>
//                     </div>
//                   </Divider>

//                   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                     {pages.map((page) => (
//                       <div
//                         key={page}
//                         className="flex justify-between items-center bg-gray-50 px-4 py-3 rounded-xl hover:shadow transition"
//                       >
//                         <span className="text-gray-700 font-medium">{page}</span>
//                         <Switch
//                           checked={!!permissions[page]}
//                           onChange={() => togglePermission(page)}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))
//             )}
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserAccessControl;
import { useState, useEffect } from "react";
import { Card, Switch, Button, Avatar, Divider, Select, message, Spin } from "antd";
import { UserOutlined, SaveOutlined, AppstoreOutlined } from "@ant-design/icons";
import { getRequest, postRequest } from "../utils/APICall";
import { IconRenderer } from "../components/Navbar/icons";

const pageGroups = {
  "Common Pages": ["Home"],
  "HR / Admin Controls": [
    "Add Leave",
    "Department",
    "Designation",
    "Employees",
    "Employee Report Emails",
    "Financial Year Leaves",
    "Holiday",
    "Mark Attendance",
    "Today Attendance",
    "Tasks",
    "Task Overview",
    "Users",
    "Users Control",
    "Worksheet",
  ],
  "Employee Self Service": ["Leaves Summary", "PaySlip", "PaySlip Structure"],
  "Report": ["Attendance Sheet", "Monthly Report", "Late Attendance Report", "Early Exit Report"],
};

const userRoles = [
  { label: "Admin", value: 1 },
  { label: "HR", value: 4 },
  { label: "Accountant", value: 5 },
  { label: "Employee", value: 2 },
  { label: "Client", value: 3 },
];

const UserAccessControl = () => {
  const [roleId, setRoleId] = useState(null);
  const [pages, setPages] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  // 🔹 Load permissions when role changes
  useEffect(() => {
    if (!roleId) return;

    const fetchPermissions = async () => {
      setLoading(true);
      try {
        const res = await getRequest(`getUserControl?roleid=${roleId}`);
        if (res.success) {
          setPages(res.data);

          // permissions map
          const permObj = {};
          res.data.forEach((p) => {
            permObj[p.PAGE_NAME] = p.CAN_ACCESS === 1;
          });
          setPermissions(permObj);
        }
      } catch (err) {
        message.error("Failed to load permissions");
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [roleId]);


  // 🔹 Toggle single permission
  const togglePermission = (page) => {
    setPermissions((prev) => ({ ...prev, [page]: !prev[page] }));
  };

  // 🔹 Toggle group permissions
  const toggleGroup = (pages, value) => {
    const updated = {};
    pages.forEach((p) => (updated[p] = value));
    setPermissions((prev) => ({ ...prev, ...updated }));
  };
  const groupedPages = pages.reduce((acc, page) => {
    const group = page.PAGE_TYPE || "Other";
    if (!acc[group]) acc[group] = [];
    acc[group].push(page);
    return acc;
  }, {});


  // 🔹 Save permissions API
  const handleSave = async () => {
    setSubmitLoading(true)
    const payload = {
      roleId,
      permissions: pages.map(p => ({
        PAGE_ID: p.PAGE_ID,
        CAN_ACCESS: permissions[p.PAGE_NAME] || false
      }))
    };
    // console.log(payload)
    try {
      const res = await postRequest("usercontrol", payload);
      // console.log(res)
      if (res.success) {
        message.success("Permissions saved successfully!");
        setPermissions({})
        setRoleId(null)
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to save permissions");
    } finally {
      setSubmitLoading(false)
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">User Page Access Control</h1>
            <p className="text-gray-500">Manage page permissions per role</p>
          </div>

          <Button
            type="primary"
            icon={<SaveOutlined />}
            size="large"
            className="rounded-xl"
            disabled={!roleId}
            onClick={handleSave}
            loading={submitLoading}
          >
            Save Changes
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Role Select */}
          <Card className="rounded-2xl shadow-sm md:col-span-1">
            <div className="flex items-center gap-4 mb-4">
              <Avatar size={48} icon={<UserOutlined />} />
              <div>
                <p className="font-semibold text-gray-800">Select Role</p>
                <p className="text-sm text-gray-500">Assign page access</p>
              </div>
            </div>

            <Select
              placeholder="Select Role"
              value={roleId}
              onChange={(value) => setRoleId(value)}
              className="w-full"
              options={userRoles}
            />
          </Card>

          {/* Access Control */}
          <Card
            className="md:col-span-3 rounded-2xl shadow-sm"
            title={
              <div className="flex items-center gap-2">
                <AppstoreOutlined />
                Page Permissions
              </div>
            }
          >
            {loading ? (
              <div className="flex justify-center py-10">
                <Spin size="large" />
              </div>
            ) : (
              Object.entries(groupedPages).map(([group, pages]) => (
                <div key={group} className="mb-8">
                  <Divider orientation="left">
                    <span className="font-semibold text-gray-700">{group}</span>
                  </Divider>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {pages.map((page) => (
                      <div
                        key={page.PAGE_ID}
                        className="flex justify-between items-center bg-gray-50 px-4 py-3 rounded-xl hover:shadow"
                      >
                        <div className="flex items-center gap-3">
                          <IconRenderer iconName={page.ICONS} />
                          <span className="font-medium text-gray-700">
                            {page.PAGE_NAME}
                          </span>
                        </div>

                        <Switch
                          checked={!!permissions[page.PAGE_NAME]}
                          onChange={() =>
                            setPermissions((prev) => ({
                              ...prev,
                              [page.PAGE_NAME]: !prev[page.PAGE_NAME],
                            }))
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default UserAccessControl;
